import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import Admin from "us.collection.admin";

interface ICntNonProductionDaysCalendar extends RouteComponentProps {}
const Cnt_NonProductionDaysCalendar: React.FC<ICntNonProductionDaysCalendar> = (
  props
) => {
  return (
    <>
      <Admin.Components.NonProductionDays.Calendar {...props} />
    </>
  );
};

export default withRouter(Cnt_NonProductionDaysCalendar);
